import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut, doDelete, doDownload, doDeleteData } from './utils'

// const API_ROOT = 'http://localhost:9004/api'
//const API_ROOT2 = 'http://localhost/api'

export const getManageAccess = () => {
  const url = `${API_ROOT}/subproject/manage-access/access/get`
  return doGet(url)
}

export const saveManageAccess = (request) => {
  const url = `${API_ROOT}/subproject/manage-access/access/save`
  return doPost(url, request)
}

export const getManageUserRoleGroup = (projectCode, pageSize, pageNumber) => {
  const url = `${API_ROOT}/subproject/manage-access/authorized/get?projectCode=${projectCode || ''}&pageNumber=${pageNumber || 0}&pageSize=${pageSize || 0}`
  return doGet(url)
}

export const getManageUserEvaluateRoleGroup = (projectCode, pageSize, pageNumber) => {
  const url = `${API_ROOT}/subproject/manage-access/authorized-evaluate/get?projectCode=${projectCode || ''}&pageNumber=${pageNumber || 0}&pageSize=${pageSize || 0}`
  return doGet(url)
}

export const getManageUserRoleGroupDeteil = (projectCode, authGroup) => {
  const url = `${API_ROOT}/subproject/manage-access/authorized/get/${projectCode}/${authGroup}/detail`
  return doPost(url)
}

export const saveManageUserRoleGroup = (request, projectCode, authGroup) => {
  const url = `${API_ROOT}/subproject/manage-access/authorized/save/${projectCode}/${authGroup}`
  return doPost(url, request)
}

export const deleteManageUserRoleGroup = (id, authGroup) => {
  const url = `${API_ROOT}/subproject/manage-access/authorized/delete/${authGroup}/${id}`
  return doDeleteData(url)
}

export const getManageUserRoleSearchName = (firstName, lastName, pageSize, pageNumber) => {
  const url = `${API_ROOT}/subproject/manage-access/authorized/search/name?firstName=${firstName || ''}&lastName=${lastName || ''}&pageNumber=${pageNumber || 0}&pageSize=${pageSize || 0}`
  return doGet(url)
}

export const getImportUserRolePage = () => {
  const url = `${API_ROOT}/subproject/manage-access/authorized/import/page`
  return doGet(url)
}

export const uploadImportUserRoleFile = (request) => {
  const url = `${API_ROOT}/subproject/manage-access/authorized/import`
  return doPost(url, request)
}

export const saveImportUserRole = (request) => {
  const url = `${API_ROOT}/subproject/manage-access/authorized/import/save`
  return doPost(url, request)
}